<mat-card>
	<mat-card-header>
		<mat-card-title *ngIf="isLoading" class="loading-width">
			Loading
			<mat-icon *ngIf="isLoading">
				<mat-spinner diameter="20"> </mat-spinner>
			</mat-icon>
			<button class="close-button" mat-mini-fab [mat-dialog-close]="true">
				<mat-icon>close</mat-icon>
			</button>
		</mat-card-title>
		<mat-card-title *ngIf="!isLoading">
			{{(searchResultDataSource ?
			(searchResultDataSource.filteredData.length < results.length ? searchResultDataSource.filteredData.length
				+ '/' : '' ) : '' ) + results.length}} Services <button class="close-button" mat-mini-fab
				[mat-dialog-close]="true">
				<mat-icon>close</mat-icon>
				</button>
				<mat-divider></mat-divider>
		</mat-card-title>
		<mat-card-subtitle *ngIf="!isLoading">
			<div class="h6">
				<div class="margin-vertical-md">
					<div>
						Service Name: {{data.ELEMENT.SERVICE_NAME}}
					</div>
					<div>
						Service Code: {{data.ELEMENT.SERVICE_CODE}}
					</div>
					<div>
						Measurable Program Objective: {{data.ELEMENT.MPO}}
					</div>
					<div>
						SSDP Components: {{(data.ELEMENT.SSDP_COMPONENTS ? data.ELEMENT.SSDP_COMPONENTS : '') | join:
						', ': 'NAME'}}
					</div>
				</div>
			</div>
			<mat-divider></mat-divider>
			<div class="h6">
				<div class="margin-vertical-md">
					<div>
						Chosen Filters:
						<mat-checkbox [color]="'primary'" class="checkbox-disabled"
							[(ngModel)]="data.expiredEligibility" (click)="$event.preventDefault()">
							Expired Eligibility</mat-checkbox>
						<mat-checkbox [color]="'primary'" class="checkbox-disabled" [(ngModel)]="data.expiredQAD"
							(click)="$event.preventDefault()">
							Expired QAD</mat-checkbox>
					</div>
					<div>
						Grades: {{(data.GRADES ? data.GRADES : '') | join: ', ': 'GRADES'}}
					</div>
					<div>
						Service Periods: {{(data.ENROLLMENT_PERIODS ? data.ENROLLMENT_PERIODS : '') | join: ', ':
						'CODE'}}
					</div>
					<div>
						Service Categories: {{(data.SERVICE_CATEGORIES ? data.SERVICE_CATEGORIES : '') | join: ', ':
						'CATEGORY'}}
					</div>
				</div>

				<div class="row">
					<mat-form-field class="col-lg-12">
						<mat-label>
							Filter
						</mat-label>
						<input matInput id="filter" name="filter" type="string" [(ngModel)]="searchResultFilter"
							(ngModelChangeDebounced)="setFilter(searchResultDataSource, searchResultFilter)" />
					</mat-form-field>
				</div>
			</div>
		</mat-card-subtitle>
	</mat-card-header>
	<mat-dialog-content *ngIf="!isLoading">
		<div class="table-responsive">
			<mat-table [dataSource]="searchResultDataSource" class="mat-elevation-z1" matSort>

				<ng-container matColumnDef="SCHOOL.DISTRICT">
					<mat-header-cell *matHeaderCellDef mat-sort-header> School District </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.SCHOOL.DISTRICT}}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="SCHOOL.NAME">
					<mat-header-cell *matHeaderCellDef mat-sort-header> School Name </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.SCHOOL.NAME}}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="MSD_NUMBER">
					<mat-header-cell *matHeaderCellDef mat-sort-header> MSD Number </mat-header-cell>
					<mat-cell *matCellDef="let element">
						<edit-child-modal-btn [studentId]="element.ID" [type]="'string'"
							[displayText]="element.MSD_NUMBER">
						</edit-child-modal-btn>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="SSID">
					<mat-header-cell *matHeaderCellDef mat-sort-header> SSID </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.SSID}}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="PERSON.LAST_NAME">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.PERSON.LAST_NAME |
						titlecase}}{{(element.SECOND_LAST_NAME
						? ' ' + element.SECOND_LAST_NAME + ',': ',') | titlecase}}
						{{element.PERSON.FIRST_NAME |
						titlecase}}
						{{element.PERSON.MIDDLE_INITIAL | titlecase}}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="STUDENT_SERVICES[0].GRADES">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Grade </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.STUDENT_SERVICES[0].GRADES}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="STUDENT_SERVICES[0].ENROLLMENT_PERIOD">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Service Period (R,I,S) </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.STUDENT_SERVICES[0].ENROLLMENT_PERIOD}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="STUDENT_SERVICES[0].START_DATE">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Start Date </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.STUDENT_SERVICES[0].START_DATE |
						simpleDate}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="STUDENT_SERVICES[0].END_DATE">
					<mat-header-cell *matHeaderCellDef mat-sort-header> End Date </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.STUDENT_SERVICES[0].END_DATE | simpleDate}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="STUDENT_SERVICES[0].COS_REASONS.REASON">
					<mat-header-cell *matHeaderCellDef mat-sort-header> COS </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.STUDENT_SERVICES[0].COS_REASONS?.REASON}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="STUDENT_SERVICES[0].SERVICE_HOUR_RANGES.MIN">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Service Hours </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.STUDENT_SERVICES[0].SERVICE_HOUR_RANGES.MAX ?
						element.STUDENT_SERVICES[0].SERVICE_HOUR_RANGES?.MIN + '-' +
						element.STUDENT_SERVICES[0].SERVICE_HOUR_RANGES.MAX :
						element.STUDENT_SERVICES[0].SERVICE_HOUR_RANGES?.MIN + '+'}}
					</mat-cell>
				</ng-container>

				<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
				<mat-row *matRowDef="let row; columns: displayedColumns;"
					[ngClass]="{'terminatedRow': row.STUDENT_TERMINATION_STATUSES?.length > 0 && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID !== 1}"
					[matTooltip]="row.STUDENT_TERMINATION_STATUSES && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES.TYPE"
					[matTooltipPosition]="'above'"
					[matTooltipDisabled]="row.STUDENT_TERMINATION_STATUSES?.length === 0 || (row.STUDENT_TERMINATION_STATUSES && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID === 1)"
					[matTooltipClass]="'terminatedTooltip'">
				</mat-row>
			</mat-table>
		</div>

		<div mat-dialog-actions class="pull-right" *ngIf="!isLoading">
			<mat-paginator #paginators [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
				aria-label="Select page of periodic elements">
			</mat-paginator>
		</div>
	</mat-dialog-content>
</mat-card>